import React, { Component } from "react";

import queryString from "query-string";

import RouteTitle from "@app/components/RouteTitle";
import Accodion from "@app/components/Accodion";
import Form from "./Form";
import List from "./List";
import ExcelDownBtn from "./CsDataExportExcel.js";
import ExcelUploadBtn from "./CsDataImportExcel.js";

import * as Constant from "@app/Constant.js";

import axios from '@app/lib/axios';
import { cssHooks } from "jquery";

class CsForm extends Component {
    constructor(props) {
        super(props);
        const query = queryString.parse(this.props.location.search);

        this.state = {
            products: [],
            types: [],
            csData: {
                id: query.id ? query.id : 0,
                product: 4,
                device: "",
                storage: "",
                version: "",
                type: 7,
                organization: "",
                requestor: "",
                phone: "",

                question: "",
                answer: "",
                is_complete: "N",
                is_issue: "N",
                request_date: new Date(),
            },
            total_cnt: 100,
            keyword: "",
            csList: [],
            listDate: new Date(),
            listLoaded: false,
            formShow: true,
            listShow: true,
            excelUploadModal: false,
            selectedPage: 0,
            pageSize: 15
        };
    }

    getDetailData = (id) => {

        axios({
            method: "get",
            url: Constant.API_DOMAIN + "/api/cs_info/detail/" + id,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    result.data.data.request_date = new Date(result.data.data.request_date);
                    this.setState({
                        csData: result.data.data,
                        formShow: true,
                    });
                } else {
                    alert(result.data.msg);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    onSearchKeyword = (keyword) => {
        this.setState({selectedPage: 0, keyword: keyword}, () => {
            this.loadMoreRows(this.state.selectedPage, keyword);
        })
    }

	onSelectPage = (selectedPage) => {
		this.setState({ selectedPage: selectedPage }, () => {
            this.loadMoreRows(selectedPage, this.state.keyword);
        });
    };

    loadMoreRows(selected, keyword) {	
		axios({
			method: "post",
			url: Constant.API_DOMAIN + "/api/cs_info/cs/list",  // Make sure this matches your server route
			data: { page: selected, size: this.state.pageSize, keyword: keyword }
		})
            .then((result) => {
                if (result.data.code === 200) {
                    this.setState({
                        csList: result.data.list,
                        total_cnt: result.data.total,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("An unknown error occurred. If the problem persists, please contact the administrator.");
            });
	}
    

    componentDidMount() {
        const query = queryString.parse(this.props.location.search);

        var date = this.state.listDate;

        var dateStr = date.getFullYear() + "-" + (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
        if (this.state.listLoaded) {
            this.setState({
                listLoaded: false,
            });
        }

        if (query.id) {
            this.getDetailData(query.id);
        }

        axios({
            method: "get",
            url: Constant.API_DOMAIN + "/api/cs_info/init/" + dateStr,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    this.setState({
                        products: result.data.products,
                        product: result.data.products[0].id,
                        types: result.data.products[0].types,
                        type: result.data.products[0].types[0].id,
                        listLoaded: true
                    }, () => {
                        this.loadMoreRows(0, 0);
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    }

    changeList = (datePram) => {
        var date = this.state.listDate;
        if (datePram) date = new Date(datePram);

        var dateStr = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        if (this.state.listLoaded) {
            this.setState({
                listLoaded: false,
            });
        }

        axios({
            method: "get",
            url: Constant.API_DOMAIN + "/api/cs_info/list/" + dateStr,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    this.setState({
                        listLoaded: true,
                        csList: result.data.list,
                        total_cnt: result.data.total,
                        listDate: date,
                        csData: {
                            id: 0,
                            product: 4,
                            device: "",
                            storage: "",
                            version: "",
                            type: 7,
                            organization: "",
                            requestor: "",
                            phone: "",

                            question: "",
                            answer: "",
                            is_complete: "N",
                            is_issue: "N",
                            request_date: new Date(),
                        },
                    });
                } else {
                    this.setState({
                        listLoaded: true,
                        listDate: date,
                    });
                    alert(result.data.msg);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    render() {
        var { formShow, listShow } = this.state;

        var accodionList = [
            {
                id: "accodion01",
                title: "문의 입력",
                component: <Form products={this.state.products} types={this.state.types} csData={this.state.csData} listCallFn={this.changeList} />,
                isShow: formShow,
            },
            {
                id: "accodion02",
                title: "일자별 목록",
                component: <List listLoaded={this.state.listLoaded} csList={this.state.csList} targetDate={this.state.listDate} rowClickCbFnc={this.getDetailData} listCallFn={this.changeList} page={this.state.selectedPage} total_cnt={this.state.total_cnt} onSelectPage={this.onSelectPage} onSearchKeyword={this.onSearchKeyword}/>,
                isShow: listShow,
            },
        ];

        return (
            <div className="dashboard-wrapper">
				<div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xs-12 col-md-8">
                            <RouteTitle title="문의 입력" />
                        </div>
                        <div className="col-xs-12 col-md-2">
                            <ExcelDownBtn btn={<button className="btn btn-info btn-block">엑셀 다운로드</button>} list={this.state.csList} />
                        </div>
                        <div className="col-xs-12 col-md-2">
                            <ExcelUploadBtn products={this.state.products} listCallFn={this.changeList} />
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <Accodion id="cs_form" contentsList={accodionList} />
                </div>
            </div>
        );
    }
}

export default CsForm;
